import type { InvoiceRecipientData } from "./types.js";
import { DataModel } from "../../base/index.js";
import type { Address, Salutation } from "../../customer/index.js";

export class InvoiceRecipient extends DataModel<InvoiceRecipientData> {
  public readonly company?: string;
  public readonly emailAddress?: string;
  public readonly firstName?: string;
  public readonly lastName?: string;
  public readonly phoneNumber?: string;
  public readonly title?: string;
  public readonly useFormalTerm?: boolean;
  public readonly address: Address;
  public readonly salutation: Salutation;
  public readonly fullName?: string;
  public readonly displayName?: string;
  public constructor(data: InvoiceRecipientData) {
    super(data);
    this.company = data.company;
    this.emailAddress = data.emailAddress;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.phoneNumber =
      data.phoneNumbers && data.phoneNumbers.length > 0
        ? data.phoneNumbers[0]
        : undefined;
    this.useFormalTerm = data.useFormalTerm;
    this.title = data.title;
    this.address = data.address;
    this.salutation = data.salutation;
    this.fullName =
      this.firstName || this.lastName
        ? `${this.data.firstName} ${this.data.lastName}`.trim()
        : undefined;
    this.displayName = this.data.company ?? this.fullName;
  }
}
